import { Injectable } from '@angular/core';
import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import moment from 'moment';

@Injectable()
export class NgbDateHelperService {
  public getDateRangeBySubtract(
    subtractAmount: moment.DurationInputArg1,
    subtractUnit: moment.DurationInputArg2,
    serverTime = new Date(),
  ): [NgbDateStruct, NgbDateStruct] {
    const minDate = moment(serverTime).subtract(subtractAmount, subtractUnit);
    const maxDate = moment(serverTime);
    return [
      {
        year: minDate.year(),
        month: minDate.month() + 1,
        day: minDate.date()
      },
      {
        year: maxDate.year(),
        month: maxDate.month() + 1,
        day: maxDate.date()
      },
    ];
  }
}
